export { TrapezoidFrame } from './trapezoid-frame';
export type { TrapezoidFrameProps } from './trapezoid-frame';
